import type { DocumentPickerAsset } from "expo-document-picker";
import type { ImagePickerAsset } from "expo-image-picker";

const getFileNameFromURI = (uri: string) => {
  const parts = uri.split("/");
  // eslint-disable-next-line unicorn/prefer-at -- better for typing purposes
  return parts[parts.length - 1];
};

const filePickerAssetFromImagePickerAsset = (
  asset: ImagePickerAsset,
): FilePickerAsset => {
  return {
    // 'file' field used only on react-native-web
    file: asset.file,
    fileName: asset.fileName || getFileNameFromURI(asset.uri),
    mimeType: asset.mimeType,
    size: asset.fileSize,
    uri: asset.uri,
  };
};

const filePickerAssetFromDocumentPickerAsset = (
  asset: DocumentPickerAsset,
): FilePickerAsset => {
  return {
    // 'file' field used only on react-native-web
    file: asset.file,
    fileName: asset.name,
    mimeType: asset.mimeType,
    size: asset.size,
    uri: asset.uri,
  };
};

export {
  filePickerAssetFromDocumentPickerAsset,
  filePickerAssetFromImagePickerAsset,
  getFileNameFromURI,
};
